import { emptyValidator, formValidator } from "../../validators";

const fuelRequestCreateValidationStatus = {
    frqJob: {
        validators: [emptyValidator()],
        name: "Job Reference",
    },
    frqCardNo: {
        validators: [emptyValidator()],
        name: "Card No",
    },
    frqRequestedAmount: {
        validators: [emptyValidator()],
        name: "Requested Fuel Amount",
    },
    frqRequiredDate: {
        validators: [emptyValidator()],
        name: "Required Date",
    },
    frqTripDistance: {
        validators: [emptyValidator()],
        name: "Trip Distance",
    },
};

const fuelRequestApproveValidationStatus = (isRejecting) => ({
    frqApprovedAmount: {
        validators: [emptyValidator()],
        name: "Approved Amount",
    },
    ...(isRejecting && {
        frqRejectRemarks: {
            validators: [emptyValidator()],
            name: "Reject Remark",
        },
    }),
});

const fuelRequestPumperValidationStatus = (isRejecting) => ({
    frqTopUpAmount: {
        validators: [emptyValidator()],
        name: "Top Up Amount",
    },
    ...(isRejecting && {
        frqRejectRemarks: {
            validators: [emptyValidator()],
            name: "Reject Remark",
        },
    }),
});

export const fuelRequestValidation = (fuelRequest, formMode = "create", isRejecting = false) => {
    switch (formMode) {
        case "approve":
            return formValidator(fuelRequest, fuelRequestApproveValidationStatus(isRejecting));
        case "pumper":
            return formValidator(fuelRequest, fuelRequestPumperValidationStatus(isRejecting));
        case "create":
        default:
            return formValidator(fuelRequest, fuelRequestCreateValidationStatus);
    }
};